import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'

const store = new Vuex.Store({
    state: {
        config: {},
        hamBurgur: false
    },
    mutations: {
        setConfig(state, config) {
            for (let key of Object.keys(config)) {
                state.config[key] = config[key];
            }
        },
        updateHamBurger: function (state, HamBurgerVal) {
            state.hamBurgur = HamBurgerVal;
        }
    },
    actions: {
        setConfig({
            commit
        }, data) {
            commit('setConfig', data);
        }
    },
    getters: {
        getConfig: (state) => (name) => {
            return state.config[name];
        },
        getHamVal: (state) => {
            return state.hamBurgur;
        }
    },
    plugins: [
        createPersistedState()
        // createPersistedState({
        //     storage: window.localStorage
        // })
    ]
});

export default store;



// WEBPACK FOOTER //
// ./src/services/store.js